import React from 'react'
import { useTranslation } from 'react-i18next'
import Tooltip from 'components/Tooltip'

interface IContainerHomePageText {
	left: string
	right: any
	xs: number[]
	tooltip: any
}

function ContainerHomePageText({
	left,
	right,
	xs,
	tooltip,
}: IContainerHomePageText) {
	const { t } = useTranslation()

	return (
		<div className="pt-1 mr-0 containerHomePageText d-flex flex-row justify-content-between">
			<div>
				{t(left)}{' '}
				{tooltip! && tooltip!.value! !== 'TotalBalanceTooltip' && (
					<Tooltip item={tooltip} />
				)}
			</div>
			<div>{right}</div>
		</div>
	)
}

export default ContainerHomePageText